'use client';

import { useWorkspaceSidebarExpansion } from '@/cms/components/blocks/workspace/workspace-1/shell/workspace-viewport';
import { CmsAccountSettingsDialogOwner } from '@/cms/components/chrome/cms-account-settings-dialog-owner';
import {
  CMS_WORKSPACE_SIDEBAR_DEFAULT_EXPANDED,
  CmsWorkspaceSidebar,
} from '@/cms/components/chrome/cms-workspace-sidebar';
import type { ProtectedWorkspaceSidebarModel } from '@/components/protected/layout/protected-workspace-sidebar-model';
import type { ReactNode } from 'react';

export function ProtectedWorkspaceSidebarShell({
  children,
  currentPath,
  locale,
  sidebar,
}: {
  children: ReactNode;
  currentPath: string;
  locale: string;
  sidebar: ProtectedWorkspaceSidebarModel;
}) {
  const {
    expanded: sidebarExpanded,
    setExpanded: setSidebarExpanded,
    viewportKind,
  } = useWorkspaceSidebarExpansion(CMS_WORKSPACE_SIDEBAR_DEFAULT_EXPANDED);

  return (
    <div
      className="cms-theme cms-theme-workspace cms-workspace-sidebar-shell min-h-screen bg-background text-on-surface"
      data-protected-workspace-sidebar-shell="true"
      data-workspace-sidebar-expanded={String(sidebarExpanded)}
      data-workspace-viewport={viewportKind}
    >
      <CmsAccountSettingsDialogOwner
        locale={locale}
        presentation={viewportKind === 'mobile' ? 'drawer' : 'dialog'}
        viewerMode="live"
      >
        <div className="flex min-h-screen w-full flex-col">
          <CmsWorkspaceSidebar
            sidebar={sidebar}
            currentPath={currentPath}
            expanded={sidebarExpanded}
            locale={locale}
            onExpandedChange={setSidebarExpanded}
          />

          <div className="cms-page-content-guard cms-workspace-sidebar-content min-w-0 flex flex-1 flex-col pl-[var(--cms-workspace-sidebar-current-width)]">
            <main className="flex-1">{children}</main>
          </div>
        </div>
      </CmsAccountSettingsDialogOwner>
    </div>
  );
}
